<template>
  <div>
    <a
      data-fancybox="gallery"
      :href="util.getImageUrl(image, '1000x1000')"
      v-for="(image, index) in util.string2Array(images)"
      :key="index"
    >
      <img :src="util.getImageUrl(image, '120x120')">
    </a>
  </div>
</template>

<script>
export default {
  name: "ProductImages",
  props: {
    images: {
      type: String,
      default: ""
    }
  }
};
</script>

<style lang="less" scoped>
.el-image,
img {
  width: 120px;
  height: 120px;
  border-radius: 10px;
  box-shadow: 0px 9px 18px 0px rgba(0, 0, 0, 0.06);

  margin-right: 10px;
}
</style>

